/* eslint-disable react-hooks/exhaustive-deps, array-bracket-newline */
import React, { useState } from 'react';
import { LS_COMPETITION_TRADES_KEY } from './Table';
import { compareNumericString } from '../../../../helpers/tableSort';

interface ITableWidths {
  date: number;
  pair: number;
  multiplier: number;
  type: number;
  price: number;
  valueUSD: number;
  points: number;
  fees: number;
}

// constants
const tableWidthsDefaultState: ITableWidths = {
  date: 176,
  pair: 120,
  multiplier: 110,
  type: 150,
  price: 150,
  valueUSD: 130,
  points: 90,
  fees: 130,
};

interface IUseTableDataProps {
  trades: any;
}

const useTableData = ({ trades }: IUseTableDataProps) => {
  const tableWidthsLC = localStorage.getItem(LS_COMPETITION_TRADES_KEY);

  const [tableColumnsWidth] = useState(
    tableWidthsLC ? JSON.parse(tableWidthsLC) : tableWidthsDefaultState
  );

  // table memoized required fields
  const data = React.useMemo(() => trades, [trades]);
  const columns = React.useMemo(
    () => [
      {
        id: 'date',
        Header: 'Date',
        accessor: 'UpdatedAt',
        width: tableColumnsWidth['date'] || tableWidthsDefaultState['date'],
        sortType: compareNumericString(),
      },
      {
        id: 'pair',
        Header: 'Pair',
        accessor: 'Pair',
        disableSortBy: true,
        width: tableColumnsWidth['pair'] || tableWidthsDefaultState['pair'],
      },
      {
        id: 'multiplier',
        Header: 'Multiplier',
        accessor: 'Multiplier',
        width:
          tableColumnsWidth['multiplier'] ||
          tableWidthsDefaultState['multiplier'],
        sortType: compareNumericString(),
      },
      {
        id: 'type',
        Header: 'Type',
        accessor: 'OrderType',
        width: tableColumnsWidth['type'] || tableWidthsDefaultState['type'],
        sortType: compareNumericString(),
      },
      {
        id: 'price',
        Header: 'Price',
        accessor: 'PriceAVG',
        width: tableColumnsWidth['price'] || tableWidthsDefaultState['price'],
        sortType: compareNumericString(),
      },
      {
        id: 'valueUSD',
        Header: 'Value ($)',
        accessor: 'FillBaseAmountUSD',
        disableSortBy: true,
        width:
          tableColumnsWidth['valueUSD'] || tableWidthsDefaultState['valueUSD'],
        sortType: compareNumericString(),
      },
      {
        id: 'points',
        Header: 'Earned points',
        accessor: 'Points',
        width: tableColumnsWidth['points'] || tableWidthsDefaultState['points'],
        sortType: compareNumericString(),
      },
      // {
      //   id: 'fees',
      //   Header: 'Paid fees',
      //   accessor: 'Fee',
      //   disableSortBy: true,
      //   width: tableColumnsWidth['fees'] || tableWidthsDefaultState['fees'],
      //   sortType: compareNumericString(),
      // },
    ],
    []
  );

  return { columns, data, tableColumnsWidth };
};

export { useTableData };
